import Link from 'next/link'
import { Typography } from '@themenu/design-system'

import { Menu } from 'components/Navigation/Menu/'
import { LogoSwile } from 'components/Image/Svg/LogoSwile'

import packageData from '../../../package.json'

export const Aside = () => {
  return (
    <aside className="fixed grid content-start [grid-area:aside] min-h-screen pt-20 pr-8 pb-24 pl-16 z-[100] -translate-x-[100vw] transition-all duration-300 ease-out md:relative md:w-auto md:z-[initial] md:translate-x-0">
      <div className="flex items-center px-14 pb-10">
        <Link href="/">
          <LogoSwile />
        </Link>
      </div>

      <Menu />

      <Typography
        variant="caption"
        className="absolute bottom-4 left-10 text-content-subdued whitespace-nowrap"
      >
        v{packageData.version} ({process.env.NEXT_PUBLIC_BUILD_ID})
      </Typography>
    </aside>
  )
}
